export default __webpack_public_path__ + "static/loans-to-go-banner-bg-3348891fda3aaf302a62b74758649b45.webp";